import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { UserCheck } from "lucide-react";
import { api, formatErr } from "../../lib/api";

export const ConvertToClient = ({ o, onDone }) => {
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  if (!o.submitted_at) return null;
  const done = o.status === "active" && o.user?.role === "client";
  const convert = () => {
    if (!window.confirm(`Se creará la ficha de cliente de ${o.player_name} con los datos del formulario y su plan, y la incorporación quedará como «Activo». ¿Continuar?`)) return;
    setBusy(true);
    api.post(`/admin/onboardings/${o.id}/convert`).then((r) => {
      toast.success(r.data.subscription_created ? "Cliente creado con su plan. Revisa el importe del plan en Gestión." : "Cliente creado");
      onDone();
      nav(`/app/admin/clients/${r.data.client_id}`);
    }).catch((e) => toast.error(formatErr(e))).finally(() => setBusy(false));
  };
  return (
    <div className="qv-card-app" style={{ padding: 18, marginBottom: 16, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap", borderLeft: `4px solid ${done ? "#22c55e" : "#E11D2E"}` }} data-testid="onb-convert-card">
      <UserCheck size={26} color={done ? "#22c55e" : "#E11D2E"} />
      <div style={{ flex: 1, minWidth: 220 }}>
        <div style={{ fontWeight: 800, fontSize: 16 }}>{done ? "Ya es cliente" : "Formulario completado: listo para crear el cliente"}</div>
        <div style={{ fontSize: 13, color: "#a3a3a3" }}>{done ? "La ficha está creada en Clientes con los datos del formulario." : !o.user ? "El futbolista aún no ha creado su cuenta desde el enlace." : "Se importan sus datos y su plan contratado a la ficha de Clientes."}</div>
      </div>
      {done
        ? <button className="qv-btn-ghost" onClick={() => nav(`/app/admin/clients/${o.user.id}`)} data-testid="onb-open-client">Abrir ficha del cliente</button>
        : <button className="qv-btn-primary" style={{ padding: "14px 22px", fontSize: 15 }} disabled={busy || !o.user} onClick={convert} data-testid="onb-convert-btn">{busy ? "Creando…" : "Convertir a cliente"}</button>}
    </div>
  );
};
